import type { PostNavigationTicket } from "@/server-types";
import { post } from "./request-helpers";

/**
 * Sets a short-lived HttpOnly cookie that stands in for the session token on
 * the URLs a browser reaches by navigating (invoice PDF, notification stream),
 * which cannot set headers. Nothing is returned — the browser attaches the
 * cookie to the navigation itself, so no credential touches the URL.
 *
 * Lives outside `paths/` because it is called from an EventSource reconnect
 * loop and a click handler rather than from a component body, so it cannot be
 * the React hook that `paths/*` exports must be.
 */
export async function prepareNavigationTicket(
  purpose: PostNavigationTicket["body"]["purpose"],
) {
  await post<PostNavigationTicket>("/verify/navigation-ticket", { purpose });
}
